module.exports = __webpack_public_path__ + "img/title_welfareList.43d57ff4.svg";